import {
    DetailedHTMLProps,
    InputHTMLAttributes,
    KeyboardEventHandler,
} from 'react'

interface InputProps
    extends DetailedHTMLProps<
        InputHTMLAttributes<HTMLInputElement>,
        HTMLInputElement
    > {
    error?: string
    onMoneyChange(value: string): void
    onKeyPressCapture?: KeyboardEventHandler
}

export function MoneyInput(props: InputProps) {
    return (
        <div>
            <div
                className="flex mt-1 relative rounded-md shadow-sm border-gray-300 hover:ing-primary-light hover:border-primary-light focus:ring-0 focus:border-none overflow-hidden"
                style={{ borderWidth: '1px' }}
            >
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <span className="text-gray-500 sm:text-sm">
                        {localStorage.getItem('default_currency')}
                    </span>
                </div>

                <input
                    {...props}
                    onChange={(e) => {
                        props.onMoneyChange(
                            parseFloat(e.target.value).toString()
                        )
                    }}
                    type="number"
                    min="0"
                    className={props.className}
                    defaultValue={props.defaultValue}
                    style={{ marginLeft: 20 }}
                />
            </div>
            {(props?.value as number) ||
                ((props?.defaultValue as number) < 0 && (
                    <span className="text-red-500 text-sm">
                        value must be positive
                    </span>
                ))}
        </div>
    )
}

export default MoneyInput
